export default {
  Pencil: 'pencil',
  Select: 'select',
  Pan: 'pan'
};
